(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-with-purchase"]) return;
  try {
    
  (() => {
    if (customElements.get('gift-with-purchase')) return;

    const SECTION = 'gift-with-purchase';
    const DISMISSED_KEY = 'skinkandy:gwp-dismissed';
    // Cart requests made by this script carry this marker so the cart watcher ignores them.
    const MARK = 'gwp=1';

    class GiftWithPurchase extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-gwp-dialog]');
        this.errorElement = this.querySelector('[data-gwp-error]');
        this.root = window.Shopify?.routes?.root || '/';
        this.status = this.readStatus(this);

        this.addEventListener('click', (event) => {
          const choose = event.target.closest('[data-gwp-choose]');
          if (choose) this.addGift(choose);
          if (event.target.closest('[data-gwp-close]')) this.dismiss();
        });
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dismiss();
        });
        this.dialog.addEventListener('cancel', () => this.remember());
        this.dialog.addEventListener('close', () => document.body.classList.remove('gwp-open'));

        this.watchCart();
        this.apply(this.status, 'load');
      }

      readStatus(root) {
        try {
          const data = JSON.parse(root.querySelector('[data-gwp-status]')?.textContent || '{}');
          return { eligible: !!data.eligible, available: !!data.available, gifts: Array.isArray(data.gifts) ? data.gifts : [] };
        } catch (error) {
          return { eligible: false, available: false, gifts: [] };
        }
      }

      async fetchStatus() {
        const response = await fetch(`${this.root}?section_id=${SECTION}&${MARK}&t=${Date.now()}`, { cache: 'no-store' });
        if (!response.ok) throw new Error(`Gift status: ${response.status}`);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        return this.readStatus(doc);
      }

      // Re-checks the cart after any add / change / update, however it was made (theme, apps, cart drawer).
      watchCart() {
        let timer;
        let added = false;
        const schedule = (isAdd) => {
          if (isAdd) added = true;
          clearTimeout(timer);
          timer = setTimeout(async () => {
            const reason = added ? 'add' : 'change';
            added = false;
            try {
              this.status = await this.fetchStatus();
              await this.apply(this.status, reason);
            } catch (error) {
              console.error('[Free gift] Cart check failed:', error);
            }
          }, 300);
        };

        if ('PerformanceObserver' in window) {
          try {
            new PerformanceObserver((list) => {
              list.getEntries().forEach((entry) => {
                const url = entry.name || '';
                if (!/\/cart\/(add|change|update|clear)/.test(url) || url.includes(MARK)) return;
                schedule(/\/cart\/add/.test(url));
              });
            }).observe({ type: 'resource', buffered: false });
          } catch (error) {
            // Older browsers: the theme's cart events below still trigger a check.
          }
        }
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event?.source !== SECTION) schedule(event?.source !== 'cart-items');
          });
        }
      }

      // Keeps the cart to the rules, then opens the popup when the cart qualifies and has no gift yet:
      // after an add, or on page load unless the customer closed it earlier in this visit.
      async apply(status, reason) {
        if (await this.enforce(status)) return;
        if (!status.eligible || !status.available || status.gifts.length) {
          if (status.gifts.length && this.dialog.open) this.dialog.close();
          return;
        }
        if (reason === 'change') return;
        if (reason === 'load' && this.wasDismissed()) return;
        this.open();
      }

      // One gift, quantity 1, and only while a qualifying product is in the cart.
      async enforce(status) {
        const updates = {};
        status.gifts.forEach((gift, index) => {
          if (!status.eligible || index > 0) updates[gift.key] = 0;
          else if (gift.quantity !== 1) updates[gift.key] = 1;
        });
        if (!Object.keys(updates).length) return false;
        try {
          const response = await this.cartRequest('update', { updates });
          this.renderCart(response, false);
          this.status = await this.fetchStatus();
        } catch (error) {
          console.error('[Free gift] Cart update failed:', error);
        }
        return true;
      }

      open() {
        if (this.dialog.open) return;
        this.errorElement.hidden = true;
        this.dialog.showModal();
        document.body.classList.add('gwp-open');
      }

      dismiss() {
        this.remember();
        this.dialog.close();
      }

      remember() {
        try {
          sessionStorage.setItem(DISMISSED_KEY, '1');
        } catch (error) {
          // Storage unavailable: the popup may show again on the next page.
        }
      }

      wasDismissed() {
        try {
          return sessionStorage.getItem(DISMISSED_KEY) === '1';
        } catch (error) {
          return false;
        }
      }

      async addGift(button) {
        if (this.busy) return;
        const item = button.closest('[data-gwp-item]');
        const variantId = Number(item?.querySelector('[data-gwp-variant]')?.value);
        if (!variantId) return;

        const buttons = Array.from(this.querySelectorAll('[data-gwp-choose]'));
        const label = button.querySelector('[data-gwp-label]');
        const original = label?.textContent;
        this.busy = true;
        buttons.forEach((choice) => (choice.disabled = true));
        if (label) label.textContent = this.dataset.labelAdding;
        this.errorElement.hidden = true;

        try {
          // Check the cart again so only one gift can ever be added (e.g. another tab added one already).
          const status = await this.fetchStatus();
          if (status.gifts.length) {
            this.status = status;
            this.dialog.close();
            return;
          }
          if (!status.eligible) throw new Error(this.dataset.errorIneligible);
          const response = await this.cartRequest('add', {
            items: [{ id: variantId, quantity: 1, properties: { _gwp: '1' } }],
          });
          this.dialog.close();
          this.renderCart(response, true);
          this.status = await this.fetchStatus();
        } catch (error) {
          this.errorElement.textContent = error.message || 'Unable to add the gift.';
          this.errorElement.hidden = false;
        } finally {
          this.busy = false;
          buttons.forEach((choice) => (choice.disabled = false));
          if (label) label.textContent = original;
        }
      }

      async cartRequest(action, body) {
        const drawer = document.querySelector('cart-drawer');
        const sections = drawer?.getSectionsToRender?.().map((section) => section.id) || ['cart-icon-bubble'];
        const response = await fetch(`${this.root}cart/${action}.js?${MARK}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ ...body, sections: sections.join(','), sections_url: window.location.pathname }),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok || data.status) throw new Error(data.description || data.message || 'Cart request failed.');
        return data;
      }

      // Refreshes the cart drawer and cart icon; the cart page reloads instead.
      renderCart(response, openDrawer) {
        if (/\/cart\/?$/.test(window.location.pathname)) {
          window.location.reload();
          return;
        }
        const drawer = document.querySelector('cart-drawer');
        const sections = response?.sections || {};
        if (drawer && openDrawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(response);
          return;
        }
        const specs = drawer?.getSectionsToRender?.() || [{ id: 'cart-icon-bubble' }];
        specs.forEach((section) => {
          const html = sections[section.id];
          const target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
          if (!html || !target) return;
          const source = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(section.selector || '.shopify-section');
          if (source) target.innerHTML = source.innerHTML;
        });
      }
    }

    customElements.define('gift-with-purchase', GiftWithPurchase);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
